const apiconfig = {
  develpoment: {
    apibaseUrl: 'https://api.onelovepc.com/onelove/',
    // apibaseUrl: 'http://192.168.1.5:8080/onelove/',
    // avdbaseUrl1: 'http://10.0.2.2:7700/onelove/',
  //   avdbaseUrl1: 'https://onelove-80825b023778.herokuapp.com/onelove/',
  },
};

export default apiconfig;